import React from 'react';
import ReactHighStock from 'react-highcharts/ReactHighstock.src';

const Chart = ({ chartInfo, symbol, price }) => {

  if (!chartInfo) {
    return (
      <div className="spinner-container">
        <div className="loader">Loading...</div>
      </div>
    );
  }

  function getColor() {
    if (price >= 0)
      return '#2ecc71';
    else return '#e74c3c';
  }

  const config =  {
    chart: {
        backgroundColor: 'transparent',
        type: 'line',
        height: '290px'
      },
      credits: {
        enabled: false
      },
      navigator: {
        enabled: false,
      },
      scrollbar: {
        enabled: false
      },
      rangeSelector: {
        enabled: false
      },
      plotOptions: {
        categories: {
          turboThreshold: 50000
        },
        series: {
          turboThreshold: 50000
        }
      },
      xAxis: {
        labels: {
          style: {
              color: '#D6D6D6'
          }
        },
      },
      yAxis: {
        labels: {
          style: {
              color: '#D6D6D6'
          }
        },
      },
      series: [{
        animation: true,
        color: getColor(),
        name: symbol,
        data: chartInfo,
        tooltip: {
          valueDecimals: 2,
          xDateFormat: "%A, %b %e, %H:%M, %Y"
        }
      }]
    };

  return (
    <ReactHighStock config={config} />
  );
}

export default Chart;